import { render, staticRenderFns } from "./StatsSalesGraph.vue?vue&type=template&id=47959e08&"
import script from "./StatsSalesGraph.vue?vue&type=script&lang=js&"
export * from "./StatsSalesGraph.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports